import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import NavSub from "../components/NavSub";
import { UserContext } from "../context/UserContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MagnifyingGlass } from "@phosphor-icons/react";
import {
  Checkbox,
  CircularProgress,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import { AuthContext } from "../context/AuthContext";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { faCaretLeft } from "@fortawesome/free-solid-svg-icons";
import HorizontalDateCalender from "./HorizontalDateCalender";
import ToastComponent from "../components/ToastComponent";
import { clientApiUrl, reportApiUrl } from "../utils/GetUrl";
import {
  CaretCircleDoubleLeft,
  CaretCircleDoubleRight,
  FileArrowUp,
  FunnelSimple,
} from "phosphor-react";
import "../Styles/DailyVoucherStock.css";
import * as XLSX from "xlsx";
import isGuestUser, { hasRole } from "../utils/guestUser";

const DailyVoucherStock = () => {
  // ///////////////////////////////////////////////////
  const containerRef = useRef(null);
  const [zIndex, setZIndex] = useState(1);

  const [projectData, setProjectData] = useState();
  const scrollDebounceRef = useRef(null);
  const lastScrollTimeRef = useRef(0);
  const isScrollingRef = useRef(false);
  const [query, setQuery] = useState("");
  const [selectedSuggestions, setSelectedSuggestions] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const debounceTimeout = useRef(null);

  const lastValidFiltersRef = useRef(null);
  const fetchSuggestionByText = async () => {
    if (!token) {
      console.error("Token is missing.");
      return;
    }

    try {
      const response = await fetch(
        `${clientApiUrl}/GetAllClient?SearchByText=${query}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      // Handle 401 Unauthorized
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error",
        );
        await logout();
        return;
      }

      // Handle session expiry
      if (handleAuthExpiry(response) === true) {
        toastRef.current.showToast("Your Session has expired", "error");
        logout();
        return false;
      }

      if (!response.ok) {
        console.error("Failed to fetch suggestions:", response.statusText);
        setSearchLoading(false);
        return;
      }

      const data = await response.json();
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Normalize to midnight for date comparison

      // Only filter by TerminationDate (ignore status)
      const activeClients = data.filter((client) => {
        if (!client.TerminationDate) return true; // Keep if no termination date

        const termDate = new Date(client.TerminationDate);
        termDate.setHours(0, 0, 0, 0);
        return termDate > today; // Only keep if termination date is in the future
      });

      setSuggestions(activeClients);
    } catch (error) {
      console.error("Error fetching data:", error);
      toastRef.current.showToast("Error fetching client data", "error");
    } finally {
      setSearchLoading(false);
    }
  };
  useEffect(() => {
    if (query.length > 0) {
      setSearchLoading(true);

      debounceTimeout.current = setTimeout(() => {
        fetchSuggestionByText();
      }, 1000);
    } else {
      setSuggestions([]);

      setSearchLoading(false);
    }

    return () => {
      clearTimeout(debounceTimeout.current);
    };
  }, [query]);

  const handleCustomersearchClick = () => {
    // return;

    setIsSearchOpen(!isSearchOpen);
  };

  const handleClearAllSearch = () => {
    setQuery("");
    setPage(1);
    setSelectedSuggestions([]);
    setSelectedEmployees([userData?.[0]]);
  };
  const handleCheckboxChange = (suggestion) => {
    if (selectedSuggestions?.length === 0) {
      setPage(1);
    }
    setSelectedSuggestions((prevSelected) => {
      if (prevSelected?.some((item) => item.Id === suggestion.Id)) {
        return prevSelected?.filter((item) => item.Id !== suggestion.Id);
      } else {
        return [suggestion];
      }
    });
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        dropdownsearchRef.current &&
        !dropdownsearchRef.current.contains(event.target)
      ) {
        setIsSearchOpen(false);
      }
    };

    const handleScroll = () => {
      setIsSearchOpen(false);
    };

    document.addEventListener("mousedown", handleOutsideClick);
    window.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // ////////////////////////////////////////////////////
  const {
    teamsData,
    setTeamsData,
    teamNames,
    setTeamNames,
    usersList,
    fetchTeams,
  } = useContext(UserContext);
  const { token, logout, handleAuthExpiry, userData } = useContext(AuthContext);

  const [teams, setTeams] = useState(
    teamNames?.filter(
      (team) =>
        team?.superTeamId === 0 && team?.type === "T" && team?.status === true,
    ),
  );
  const [isAccountResponsibleOpen, setIsAccountResponsibleOpen] = useState();
  const [selectedPrepareName, setSelectedPrepareName] = useState(userData?.[0]);
  const [accSearch, setAccSearch] = useState("");
  const [accountResponsible, setAccountResponsible] = useState([]);
  const [accountResponsible2, setAccountResponsible2] = useState([]);
  const [selectedAccountResponsible, setSelectedAccountResponsible] = useState(
    [],
  );
  const dropdownsearchRef = useRef(null);
  const { toastRef } = useRef();
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedClient, setSelectedClient] = useState({});
  const todaysDate = new Date();
  const [selectedYear, setSelectedYear] = useState(todaysDate.getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(
    todaysDate.toLocaleString("default", { month: "long" }),
  );
  const [selectedDay, setSelectedDay] = useState(todaysDate.getDate());

  const [isTableLoaded, setIsTableLoaded] = useState(false);

  const handleCheckboxAccountResponsibleChange = (acc) => {
    // Clear teams when selecting preparer
    setSelectedTeams([]);
    setSelectedOption({});

    // If clicking on the already selected item, clear the selection
    if (selectedPrepareName?.EM_ID === acc?.EM_ID) {
      setSelectedPrepareName(null);
      setSelectedAccountResponsible([]);
      setSelectedEmployees([]);
      return;
    }

    // Select the new preparer
    setSelectedAccountResponsible([acc]);
    setPage(1);
    setSelectedClient([]);
    setSelectedEmployees([acc]);
    setSelectedPrepareName(acc);
  };
  useEffect(() => {
    setAccountResponsible(usersList);
    setAccountResponsible2(usersList);
  }, [usersList]);

  const toggleTeamSelector = () => {
    // setTeamSelectorOpen((prev) => !prev);
  };

  useEffect(() => {
    setSelectedEmployees([userData?.[0]]);
  }, [userData]);

  const handleAccountingResponsibleClick = () => {
    if (selectedTeams.length > 0) return; // Prevent opening if teams are selected
    setIsAccountResponsibleOpen((prevState) => !prevState);
  };

  const handleChange = (event) => {
    if (event.target.value?.[event.target.value?.length - 1] === undefined) {
      setSelectedTeams([]);
      setSelectedPrepareName(null);
      setSelectedAccountResponsible([]);
      setSelectedEmployees([]);
      return;
    }

    // Clear ALL preparer-related states when selecting teams
    setSelectedPrepareName(null);
    setSelectedAccountResponsible([]);
    setSelectedSuggestions([]);

    // Set the selected teams
    setSelectedTeams(event.target.value);
    setSelectedEmployees([]);
  };
  const handleClearAll = (event) => {
    event.preventDefault();
    setSelectedTeams([]);
    setSelectedPrepareName(null);
    setSelectedAccountResponsible([]);
    setSelectedEmployees([]);
  };
  useEffect(() => {
    if (!selectedTeams?.length && !isConsultant()) {
      setSelectedEmployees([userData?.[0]]);
    }
  }, [selectedTeams, token]);

  useEffect(() => {
    const filteredEmployees = usersList?.filter((user) =>
      selectedTeams?.includes(parseInt(user?.STM_Team)),
    );
    setSelectedEmployees(filteredEmployees);
  }, [selectedTeams, usersList, token]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownsearchRef.current &&
        !dropdownsearchRef.current.contains(event.target)
      ) {
        setIsAccountResponsibleOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownsearchRef]);

  const [expanded, setExpanded] = useState(true);

  //fetching data
  const [page, setPage] = useState(1);
  const [masterData, setMasterData] = useState([]);
  const [mergedData, setMergedData] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [end, setEnd] = useState(false);
  const fetchInProgress = useRef(false); //

  const isConsultant = () => {
    if (hasRole(userData?.[0]?.DR_Name, "Consultant")) {
      return true;
    }
    return false;
  };

  useEffect(() => {
  }, [selectedEmployees, selectedTeams, token]);

  const [selectedFrequencyId, setSelectedFrequencyId] = useState("");
  const [reportingFrequencyId, setReportingFrequencyId] = useState("");
  const fetchProjectList = async () => {
    try {
      const response = await fetch(`${clientApiUrl}/GetAllProjectList`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        setProjectData(data);
      } else {
        console.error("Failed to fetchProjectList data");
      }
    } catch (error) {
    }
  };
  useEffect(() => {
    if (token) fetchProjectList();
  }, [token]);

  const fetchCustomer = async (
    dateStart,
    dateEnd,
    first,
    reportingFrequencyId,
  ) => {

    if (!token) {
      return;
    }

    // Store filters when we have them (for page 1)
    if (
      first &&
      (selectedEmployees?.length > 0 || selectedSuggestions?.length > 0)
    ) {
      lastValidFiltersRef.current = {
        selectedEmployees,
        selectedSuggestions,
        reportingFrequencyId,
        selectedPrepareName,
      };
    }

    // For page 2+, use last valid filters if current ones are empty
    let filtersToUse = {};
    if (!first && !selectedEmployees?.length && !selectedSuggestions?.length) {
      if (lastValidFiltersRef.current) {
        filtersToUse = lastValidFiltersRef.current;
      } else {
        filtersToUse = {
          selectedEmployees: selectedEmployees || [],
          selectedSuggestions: selectedSuggestions || [],
          reportingFrequencyId,
          selectedPrepareName,
        };
      }
    } else {
      filtersToUse = {
        selectedEmployees: selectedEmployees || [],
        selectedSuggestions: selectedSuggestions || [],
        reportingFrequencyId,
        selectedPrepareName,
      };
    }

    if (fetchInProgress.current) {
      return;
    }

    fetchInProgress.current = true;
    setLoading(true);

    try {
      const date = formatDate(selectedDay, selectedMonth, selectedYear);
      const clientId = filtersToUse.selectedSuggestions?.[0]?.Id;
      const itemsPerPage = filtersToUse.reportingFrequencyId
        ? 50
        : clientId
          ? 1
          : 50;

      // Build the API URL
      let apiUrl = `${clientApiUrl}/GetAllClient?Page=${page}&ItemsPerPage=${itemsPerPage}&CreatDate=${date}`;

      // Add client ID if exists
      if (clientId) {
        apiUrl += `&id=${clientId}`;
      }
      // Add employee filter if exists
      else if (
        filtersToUse.selectedEmployees?.length > 0 ||
        filtersToUse.selectedPrepareName
      ) {
        // Get all valid employees with EM_ID
        const validEmployees = filtersToUse.selectedEmployees.filter(
          (emp) => emp && emp.EM_ID,
        );

        if (validEmployees.length > 0) {
          // FIXED: Format GUIDs with single quotes as your example shows
          const emIds = validEmployees.map((item) => `'${item["EM_ID"]}'`);

          apiUrl += `&SubOwnerEMIDs=${emIds.join(",")}`;

        } else {
          // Fallback to selectedPrepareName if available
          if (filtersToUse.selectedPrepareName?.EM_ID) {
            apiUrl += `&SubOwnerEMIDs='${filtersToUse.selectedPrepareName.EM_ID}'`;
          }
        }
      } else {
      }

      // Add frequency ID if exists
      if (filtersToUse.reportingFrequencyId) {
        apiUrl += `&ReportingFrequencyID=${filtersToUse.reportingFrequencyId}`;
      }


      const response = await fetch(apiUrl, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error",
        );
        await logout();
        return;
      }

      const handleAuthError = handleAuthExpiry(response);
      if (handleAuthError === true) {
        toastRef.current.showToast("Your Session has expired", "error");
        logout();
        return false;
      }

      if (!response.ok) {
        console.error("Failed to fetch:", response.statusText);
        setLoading(false);
        return;
      }

      const data = await response.json();

      // Filter out terminated clients
      const activeData = data.filter(
        (d) => d?.Status?.trim().toLowerCase() !== "terminated",
      );


      // If first page is empty, show "No data"
      if (first && activeData.length === 0) {
        setEnd(true);
        setMergedData([]);
        return;
      }

      // If subsequent page is empty, we've reached the end
      if (!first && activeData.length === 0) {
        setEnd(true);
        return;
      }

      const formattedIds = activeData.map((d) => `'${d?.Id}'`).join(", ");

      await fetchedReportsPerClient(
        activeData,
        formattedIds,
        dateStart,
        dateEnd,
        filtersToUse.reportingFrequencyId,
        first,
      );

      // Update end state
      if (activeData.length === 0) {
        setEnd(true);
      } else {
        setEnd(false);
      }
    } catch (error) {
      console.error("❌ Error fetching data:", error);
      toastRef.current.showToast(
        "Error fetching data. Please try again.",
        "error",
      );
    } finally {
      setLoading(false);
      fetchInProgress.current = false;
    }
  };
  // Update fetchedReportsPerClient to handle appending data:
  const fetchedReportsPerClient = async (
    clientData,
    ids,
    dateStart,
    dateEnd,
    reportingFrequencyId,
    isFirstFetch = false,
  ) => {
    if (!ids || !dateStart || !dateEnd) return;

    try {
      const response = await fetch(
        `${reportApiUrl}/GetReports?ClientId=${ids}&DteRange1=${dateStart}&DteRange2=${dateEnd}${
          reportingFrequencyId
            ? `&ReportingFrequencyID=${reportingFrequencyId}`
            : ""
        }`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error",
        );
        await logout();
        return;
      }

      const handleAuthError = handleAuthExpiry(response);
      if (handleAuthError === true) {
        toastRef.current.showToast("Your Session has expired", "error");
        logout();
        return false;
      }

      if (response.ok) {
        const data = await response.json();

        const currentMergedData = clientData.map((client) => {
          const matchingReport = data.find(
            (report) => report.ClientId === client.Id,
          );

          const defaultReportFields = {
            Id: null,
            ReceivedVolume: "",
            PendingVolume: "",
            Volume2: "",
            CommentOfVolume: "",
            PaymentCheck: "",
            PaymentStatus: "",
            CommentOfPaymentFaild: "",
            ReportType: "",
            ReceivedDate: "",
            DueDate: "",
            DateOfSubmission: "",
            ClientId: client.Id,
            CreatedBy: "",
            SynergyPreparer: "",
            CreateDate: "",
          };

          return {
            ...client,
            ...(matchingReport || defaultReportFields),
          };
        });

        // Append new data to existing data for infinite scroll
        if (isFirstFetch) {
          setMergedData(currentMergedData);
        } else {
          setMergedData((prev) => [...prev, ...currentMergedData]);
        }

        setIsTableLoaded(true);
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
    }
  };
  const handleScroll = useCallback(() => {
    const container = containerRef.current;

    if (
      !container ||
      loading ||
      end ||
      !mergedData.length ||
      fetchInProgress.current
    ) {
      return;
    }

    const { scrollTop, scrollHeight, clientHeight } = container;

    // Clear any existing timeout
    if (scrollDebounceRef.current) {
      clearTimeout(scrollDebounceRef.current);
    }

    // Use debounce
    scrollDebounceRef.current = setTimeout(() => {
      if (scrollTop + clientHeight >= scrollHeight - 100) {

        // Use functional update to ensure correct sequence
        setPage((prevPage) => {
          const newPage = prevPage + 1;
          return newPage;
        });
      }
    }, 150);
  }, [loading, end, mergedData.length, page]);
  // Add this cleanup useEffect
  useEffect(() => {
    return () => {
      if (scrollDebounceRef.current) {
        clearTimeout(scrollDebounceRef.current);
      }
    };
  }, []);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    let lastScrollLeft = 0;
    let lastScrollTop = 0;

    const handleContainerScroll = () => {
      const scrollLeft = container.scrollLeft;
      const scrollTop = container.scrollTop;

      // Handle z-index for side scrolling
      const isHorizontalScroll = scrollLeft !== lastScrollLeft;
      const isVerticalScroll = scrollTop !== lastScrollTop;

      if (isHorizontalScroll) {
        setZIndex();
      } else if (isVerticalScroll) {
        setZIndex(1);
      }

      lastScrollLeft = scrollLeft;
      lastScrollTop = scrollTop;

      // Call handleScroll for infinite scroll
      handleScroll();
    };

    container.addEventListener("scroll", handleContainerScroll);

    return () => {
      container.removeEventListener("scroll", handleContainerScroll);
    };
  }, [handleScroll]);
  // Update the useEffect that checks for empty selectedEmployees
  useEffect(() => {

    // Skip if this is triggered by scrolling
    if (page > 1) {
      return;
    }

    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    // Reset states for new fetch (only on filter changes)
    setEnd(false);
    setPage(1);
    setMasterData([]);

    // Only fetch if there are selected employees OR a specific client is selected
    if (selectedEmployees?.length > 0 || selectedSuggestions?.length > 0) {
      const dateStart = formatDate(selectedDay, selectedMonth, selectedYear);
      const dateEnd = formatDate(selectedDay, selectedMonth, selectedYear);

      fetchCustomer(dateStart, dateEnd, true, selectedFrequencyId);
    } else {
      setMergedData([]);
      setEnd(true);
    }
  }, [
    selectedDay,
    selectedMonth,
    selectedYear,
    selectedEmployees,
    selectedSuggestions,
    selectedFrequencyId,
  ]);
  const isInitialRender = useRef(true);
  useEffect(() => {
    const container = document.querySelector(".scroll-hardware");
    if (!container) return;

    const handleScrollEvent = () => {
      if (!loading && !end && mergedData.length) {
        handleScroll();
      }
    };

    container.addEventListener("scroll", handleScrollEvent);

    return () => {
      container.removeEventListener("scroll", handleScrollEvent);
    };
  }, [handleScroll, loading, end, mergedData]);

  useEffect(() => {

    const dateStart = formatDate(selectedDay, selectedMonth, selectedYear);
    const dateEnd = formatDate(selectedDay, selectedMonth, selectedYear);

    // Always fetch when page changes
    fetchCustomer(dateStart, dateEnd, page === 1, selectedFrequencyId);
  }, [
    page,
    selectedFrequencyId,
    selectedDay,
    selectedMonth,
    selectedYear,
    // Don't include selectedEmployees or selectedSuggestions here
    // They cause unnecessary re-fetches and can be empty on page 2
  ]);

  // Update the useEffect that checks for empty selectedEmployees
  // Update the useEffect that checks for empty selectedEmployees
  useEffect(() => {

    // If we're scrolling, don't reset page
    if (isScrollingRef.current) {
      isScrollingRef.current = false;
      return;
    }

    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    // Reset states for new fetch (only on filter changes)
    setEnd(false);
    setPage(1); // Reset to page 1 only on filter changes
    setMasterData([]);

    // Only fetch if there are selected employees OR a specific client is selected
    if (selectedEmployees?.length > 0 || selectedSuggestions?.length > 0) {
      const dateStart = formatDate(selectedDay, selectedMonth, selectedYear);
      const dateEnd = formatDate(selectedDay, selectedMonth, selectedYear);

      fetchCustomer(dateStart, dateEnd, true, selectedFrequencyId);
    } else {
      setMergedData([]);
      setEnd(true);
    }
  }, [
    selectedDay,
    selectedMonth,
    selectedYear,
    selectedEmployees,
    selectedSuggestions,
    selectedFrequencyId,
  ]);

  // Add this cleanup useEffect
  useEffect(() => {
    return () => {
      // Clean up any pending timeouts
      if (scrollDebounceRef.current) {
        clearTimeout(scrollDebounceRef.current);
      }
    };
  }, []);
  const getUserFirstName = (emId) => {
    const user = usersList?.find((user) => user.EM_ID === emId);
    return user ? user.EM_FirstName + " " + user.EM_LastName : "";
  };

  const debounceRef = useRef(null); // A ref to hold the debounce timeout

  const handleReportChange = async (data, val, e) => {
    const isToday = () =>
      new Date(
        formatDate(selectedDay, selectedMonth, selectedYear),
      ).toDateString() === new Date().toDateString();
    if (!isToday()) {
      toastRef.current.showToast(`Please Select Today's Date`, "error");
      alert(`Please Select Today's Date`);
      return;
    }

    if (isGuestUser(userData?.[0]?.DRM_ID)) {
      alert(`Guest User Does not have Add or Edit Access`);

      return;
    }
    const EM_ID = userData?.[0]?.EM_ID; // Assuming userData is coming from context or props

    if (!EM_ID) {
      console.error("Failed to retrieve user ID or Client ID.");
      return;
    }

    // Update the mergedData state with the new value
    const updatedMergedData = mergedData.map((item) => {
      if (item.ClientId === data.ClientId) {
        return { ...item, [val]: e.target.value }; // Dynamically update the field based on val
      }
      return item;
    });

    setMergedData(updatedMergedData);

    const updatedItem = updatedMergedData.find(
      (item) => item.ClientId === data.ClientId,
    );

    let payload;
    if (data.Id === null) {
      payload = {
        ClientId: data.ClientId,
        ReceivedVolume: Number(updatedItem.ReceivedVolume) || 0,
        Volume2: Number(updatedItem.Volume2) || 0,
        PendingVolume:
          Number(updatedItem.ReceivedVolume - updatedItem.StatusCount) || 0,
        CommentOfVolume: updatedItem.CommentOfVolume || "",
        PaymentCheck: updatedItem.PaymentCheck || "",
        PaymentStatus: updatedItem.PaymentStatus || "",
        CommentOfPaymentFaild: updatedItem.CommentOfPaymentFaild || "",
        ReportType: "Daily Voucher",
        ReceivedDate: "",
        DueDate: "",
        DateOfSubmission: todaysDate,
        CreatedBy: EM_ID,
        SynergyPreparer: "",
      };
    } else {
      payload = {
        TaskReportId: data.Id,
        ClientId: data.ClientId,
        ReceivedVolume: Number(updatedItem.ReceivedVolume) || 0,
        Volume2: Number(updatedItem.Volume2) || 0,
        PendingVolume:
          Number(updatedItem.ReceivedVolume - updatedItem.StatusCount) || 0,
        CommentOfVolume: updatedItem.CommentOfVolume || "",
        PaymentCheck: updatedItem.PaymentCheck || "",
        PaymentStatus: updatedItem.PaymentStatus || "",
        CommentOfPaymentFaild: updatedItem.CommentOfPaymentFaild || "",
        ReportType: "Daily Voucher",
        ReceivedDate: "",
        DueDate: "",
        DateOfSubmission: todaysDate,
        CreatedBy: EM_ID,
        SynergyPreparer: "",
      };
    }

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(async () => {
      try {
        const url =
          data.Id === null
            ? `${reportApiUrl}/AddTaskReport`
            : `${reportApiUrl}/UpdateTaskReport`;

        const method = data.Id === null ? "POST" : "PUT";

        const response = await fetch(url, {
          method,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        });

        if (response.status === 401) {
          toastRef.current.showToast(
            "Unauthorised access. Please login again.",
            "error",
          );
          await logout();
          return;
        }

        const handleAuthError = handleAuthExpiry(response);
        if (handleAuthError === true) {
          toastRef.current.showToast("Your Session has expired", "error");
          logout();
          return false;
        }

        if (response.ok) {
          const result = await response.json();

          if (method === "POST") {
            // Fetch the newly created report's ID using the GET endpoint
            const reportResponse = await fetch(
              `${reportApiUrl}/GetReports?ClientId='${
                data.ClientId
              }'&DteRange1=${formatDate(
                selectedDay,
                selectedMonth,
                selectedYear,
              )}&DteRange2=${formatDate(
                selectedDay,
                selectedMonth,
                selectedYear,
              )}`,

              {
                method: "GET",
                headers: {
                  Authorization: `Bearer ${token}`, // Assuming `token` is defined elsewhere
                },
              },
            );

            if (response.status === 401) {
              toastRef.current.showToast(
                "Unauthorised access. Please login again.",
                "error",
              );
              await logout();
              return;
            }

            const handleAuthError = handleAuthExpiry(response);
            if (handleAuthError === true) {
              toastRef.current.showToast("Your Session has expired", "error");
              logout();
              return false;
            }

            if (reportResponse.ok) {
              const reportData = await reportResponse.json();

              // Update mergedData with reportId
              const updatedMergedDataWithReportId = mergedData.map((item) => {
                if (item.ClientId === data.ClientId) {
                  return {
                    ...item,
                    Id: reportData?.[0]?.Id, // Update the Id field with the reportData Id

                    ReceivedVolume:
                      updatedItem.ReceivedVolume || item.ReceivedVolume,
                    Volume2: updatedItem.Volume2 || item.Volume2,
                    PendingVolume:
                      updatedItem.PendingVolume || item.PendingVolume,
                    CommentOfVolume:
                      updatedItem.CommentOfVolume || item.CommentOfVolume,
                    PaymentCheck: updatedItem.PaymentCheck || item.PaymentCheck,
                    PaymentStatus:
                      updatedItem.PaymentStatus || item.PaymentStatus,
                    CommentOfPaymentFaild:
                      updatedItem.CommentOfPaymentFaild ||
                      item.CommentOfPaymentFaild,
                    ClientId: updatedItem.ClientId || item.ClientId,
                    CreatedBy: updatedItem.CreatedBy || item.CreatedBy,
                  };
                }
                return item;
              });

              setMergedData(updatedMergedDataWithReportId);
            }
          }
        } else {
          console.error(
            `Error ${method === "POST" ? "adding" : "updating"} data:`,
            response.statusText,
          );
        }
      } catch (error) {
        console.error("Error making API call:", error);
      } finally {
        debounceRef.current = null;
      }
    }, 1000);
  };

  const dropdownRef = useRef(null);
  const getLastDayOfMonth = (year, month) => {
    return new Date(year, month, 0).getDate();
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen); // Toggle dropdown visibility
  };
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async (reportType) => {
    if (!selectedDay || !selectedMonth || !selectedYear) {
      toastRef.current.showToast("Please select a valid date.", "error");
      return;
    }

    if (isGuestUser(userData?.[0]?.DRM_ID)) {
      toastRef.current.showToast(`Guest User does not have Add or Edit access`);
      return;
    }

    setIsDownloading(true);

    try {
      const formattedDate = formatDate(
        selectedDay,
        selectedMonth,
        selectedYear,
      );

      const monthMapping = {
        January: "01",
        February: "02",
        March: "03",
        April: "04",
        May: "05",
        June: "06",
        July: "07",
        August: "08",
        September: "09",
        October: "10",
        November: "11",
        December: "12",
      };

      const formattedMonth = monthMapping[selectedMonth];
      const lastDayOfMonth = getLastDayOfMonth(selectedYear, formattedMonth);

      const selectedTeamNames = selectedTeams
        .map((teamId) => teams.find((team) => team.id === teamId)?.name)
        .filter(Boolean)
        .join(", ");

      const preparerName = selectedPrepareName
        ? `${selectedPrepareName.EM_FirstName} ${selectedPrepareName.EM_LastName}`
        : "";

      let bodyData = {};

      if (reportType === "Daily") {
        bodyData = {
          DateRange1: formattedDate,
          DateRange2: formattedDate,
          ReportType: "Daily Voucher",
          TeamName: selectedTeamNames,
          PreparerName: preparerName,
        };
      } else if (reportType === "Monthly") {
        bodyData = {
          DateRange1: `${selectedYear}-${formattedMonth}-01`,
          DateRange2: `${selectedYear}-${formattedMonth}-${String(lastDayOfMonth).padStart(2, "0")}`,
          ReportType: "Daily Voucher",
          TeamName: selectedTeamNames,
          PreparerName: preparerName,
        };
      }

      const response = await fetch(`${reportApiUrl}/GetReportFile`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });

      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorized access. Please login again.",
          "error",
        );
        await logout();
        return;
      }

      const handleAuthError = handleAuthExpiry(response);
      if (handleAuthError === true) {
        toastRef.current.showToast("Your session has expired", "error");
        logout();
        return;
      }

      const result = await response.json();
      if (result.Status) {
        const fileUrl = result.Result.URI;
        window.location.href = fileUrl;
      } else {
        console.error("Error in fetching report:", result);
        toastRef.current.showToast("Failed to fetch report.", "error");
      }
    } catch (error) {
      console.error("Error in fetch:", error);
      toastRef.current.showToast(
        "Something went wrong during download.",
        "error",
      );
    } finally {
      setIsDownloading(false);
    }
  };

  const formatDate = (day, month, year) => {
    const monthMapping = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };

    const formattedMonth = monthMapping[month];
    const formattedDay = String(day).padStart(2, "0");
    return `${year}-${formattedMonth}-${formattedDay}`;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getUserTeamName = (emId) => {
    const user = usersList?.find((user) => user.EM_ID === emId);
    return user
      ? teamNames?.find((team) => team.id === parseFloat(user.STM_Team))
          ?.name || "Unknown Team"
      : "Unknown Team"; // Return team name or default to "Unknown Team"
  };

  return (
    <div>
      <NavSub />
      <ToastComponent ref={toastRef} timeout={4000} />

      <div
        style={{
          display: "flex",
          gap: "28px",
          padding: "20px 24px",
          width: "98%",
          margin: "1rem auto",
          background: "white",
          borderRadius: "10px",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", gap: "28px" }}>
          {!isConsultant() && (
            <FormControl className="select-dropdown-user">
              <InputLabel
                id="team-selector-label"
                className="select-dropdown-label"
                shrink={false}
                onClick={toggleTeamSelector}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: selectedPrepareName ? "not-allowed" : "pointer",
                  color: selectedPrepareName ? "#ccc" : "inherit",
                }}
              >
                Select Teams
              </InputLabel>

              <Select
                labelId="team-selector-label"
                id="team-selector"
                multiple
                value={selectedTeams}
                onChange={handleChange}
                disabled={!!selectedPrepareName} // Disable when preparer is selected
                renderValue={(selected) =>
                  selected
                    .map((teamId) => {
                      const team = teams.find((team) => team.id === teamId);
                      return team?.Name;
                    })
                    .join(" ")
                }
                style={{
                  width: "150px",
                  cursor: selectedPrepareName ? "not-allowed" : "pointer",
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 250,
                    },
                  },
                }}
              >
                {selectedTeams?.length > 0 && !selectedPrepareName && (
                  <MenuItem onClick={(e) => handleClearAll(e)}>
                    <ListItemText
                      style={{ color: "red" }}
                      primary={"Clear All"}
                    />
                  </MenuItem>
                )}
                {teams.map((team) => (
                  <MenuItem
                    key={team.id}
                    value={team.id}
                    disabled={!!selectedPrepareName} // Also disable menu items
                  >
                    <Checkbox
                      checked={selectedTeams.indexOf(team.id) > -1}
                      disabled={!!selectedPrepareName}
                    />
                    <ListItemText primary={team.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          <div
            className="Title-STR-main2"
            onClick={handleAccountingResponsibleClick}
            style={{
              cursor: selectedTeams.length > 0 ? "not-allowed" : "pointer",
              opacity: selectedTeams.length > 0 ? 0.6 : 1,
            }}
          >
            {selectedTeams.length > 0
              ? "Select Preparer"
              : selectedPrepareName
                ? `${selectedPrepareName.EM_FirstName} ${selectedPrepareName.EM_LastName}`
                : "Preparer Name"}
            <FontAwesomeIcon
              className="str-caret-icon"
              icon={isAccountResponsibleOpen ? faCaretUp : faCaretDown}
              style={{
                pointerEvents: selectedTeams.length > 0 ? "none" : "auto",
              }}
            />
            {isAccountResponsibleOpen &&
              !isConsultant() &&
              !selectedTeams.length && (
                <div
                  ref={dropdownsearchRef}
                  className="search-drop-DailyVoucher"
                >
                  <div className="search-drop-page">
                    <div className="main-suggestion">
                      <div className="input-suggestion">
                        <div className="icon-search-phospher">
                          <MagnifyingGlass
                            size={20}
                            color="#ada4a4"
                            weight="fill"
                          />
                        </div>
                        <input
                          type="text"
                          value={accSearch}
                          className="input-suggestion-search"
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => {
                            const value = e.target.value.toLowerCase();
                            setAccSearch(value);
                            setAccountResponsible2(
                              accountResponsible?.filter((acc) =>
                                (acc.EM_FirstName + " " + acc?.EM_LastName)
                                  .toLowerCase()
                                  .includes(value),
                              ),
                            );
                          }}
                          placeholder="Start typing..."
                        />
                      </div>
                      <div tabIndex={1}>
                        <div
                          style={{ color: "red", padding: "2px 22px" }}
                          onClick={() => {
                            setSelectedPrepareName(null);
                            setSelectedAccountResponsible([]);
                            setSelectedEmployees([]);
                          }}
                        >
                          Clear All
                        </div>
                        {accountResponsible2?.map((acc) => (
                          <div key={acc.EM_ID} className="suggestion-list-li">
                            <input
                              type="radio"
                              className="radio-searchbox"
                              style={{
                                accentColor: "rgb(80, 20, 90)",
                                width: "18px",
                                height: "18px",
                                cursor: "pointer",
                              }}
                              checked={selectedAccountResponsible?.some(
                                (item) => item.EM_ID === acc?.EM_ID,
                              )}
                              onChange={() =>
                                handleCheckboxAccountResponsibleChange(acc)
                              }
                            />
                            <label className="li-content">
                              {acc.EM_FirstName + " " + acc.EM_LastName}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>

        <div className="custom-dropdown-container">
          <div className="Nav-btn-user-download">
            <FileArrowUp size={25} color="#3d025f" weight="fill" />
            <div className="custom-dropdown" ref={dropdownRef}>
              <button
                className="dropdown-btn"
                onClick={toggleDropdown}
                disabled={isDownloading}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: isDownloading ? "not-allowed" : "pointer",
                }}
              >
                {isDownloading ? (
                  <>
                    <span>Downloading...</span>
                    <span
                      style={{
                        border: "3px solid #f3f3f3",
                        borderTop: "3px solid #3d025f",
                        borderRadius: "50%",
                        width: "16px",
                        height: "16px",
                        animation: "spin 1s linear infinite",
                      }}
                    ></span>
                    <style>
                      {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
                    </style>
                  </>
                ) : (
                  "Download File"
                )}
              </button>

              {isOpen && (
                <div className="dropdown-content-download">
                  <div
                    className="dropdown-item"
                    onClick={() => {
                      setSelectedOption("Daily");
                      handleDownload("Daily");
                      setIsOpen(false); // Close dropdown after selection
                    }}
                  >
                    Daily Reports
                  </div>
                  <div
                    className="dropdown-item"
                    onClick={() => {
                      setSelectedOption("Monthly");
                      handleDownload("Monthly");
                      setIsOpen(false); // Close dropdown after selection
                    }}
                  >
                    Monthly Reports
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div style={{ width: "98%", margin: "1rem auto" }}>
        <HorizontalDateCalender
          selectedDay={selectedDay}
          setSelectedDay={setSelectedDay}
          selectedMonth={selectedMonth}
          setSelectedMonth={setSelectedMonth}
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
          showDotIndicator={true}
        />
      </div>

      <div
        ref={containerRef} // Add this
        style={{
          width: "98%",

          margin: "0px 10px 0px 10px",
          overflow: "auto",
          maxHeight: "calc(100vh - 350px)",
        }}
        className="scroll-hardware custom-scrollbar"
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontFamily: "Arial, sans-serif",
          }}
          className="Daily_table_stck "
        >
          <thead>
            <tr>
              <th
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 999,
                  left: 0,
                  background: "#d9d9d9",
                }}
                className="header-customername "
              >
                <div
                  style={{
                    display: "flex",
                    // justifyContent: "space-between",
                    alignItems: "center",
                    position: "sticky",
                    position: "sticky",
                    left: 0,
                    gap: "16px",
                  }}
                >
                  Customer Name
                  <FunnelSimple
                    className="icon-search-dropdown"
                    onClick={handleCustomersearchClick}
                    weight="bold"
                    size={20}
                    color="#061347"
                  />
                </div>

                {isSearchOpen && (
                  <div
                    ref={dropdownsearchRef}
                    className="search-drop-design-report"
                    style={{
                      marginLeft: "140px !important",
                      marginTop: "23px !important",
                    }}
                  >
                    <div className="search-drop-page">
                      <div className="main-suggestion">
                        <div className="input-suggestion">
                          <div className="icon-search-phospher">
                            <MagnifyingGlass
                              size={20}
                              color="#ada4a4"
                              weight="fill"
                            />{" "}
                          </div>

                          <input
                            type="text"
                            value={query}
                            className="input-suggestion-search"
                            onChange={(e) => setQuery(e.target.value)}
                            placeholder="Start typing..."
                          />

                          <button
                            className="clear-title"
                            onClick={handleClearAllSearch}
                          >
                            Clear All
                          </button>
                        </div>
                        {searchLoading ? (
                          <p className="suggestion-title">
                            <CircularProgress
                              width={30}
                              style={{ color: "purple" }}
                            />
                          </p>
                        ) : (
                          <div style={{ maxHeight: "500px" }} tabIndex={1}>
                            {suggestions.map((suggestion) => (
                              <div
                                key={suggestion.Id}
                                className="suggestion-list-li"
                              >
                                <input
                                  type="checkbox"
                                  className="check-searchbox"
                                  checked={selectedSuggestions.some(
                                    (item) => item.Id === suggestion.Id,
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(suggestion)
                                  }
                                />
                                <label className="li-content">
                                  {suggestion.Name}
                                </label>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </th>
              <th
                style={{
                  backgroundColor: "#d9d9d9",
                  color: "#000",
                  position: "relative",
                  minWidth: "300px",
                  textAlign: "start",
                  position: "sticky",
                  top: 0,
                  left: "300px",
                  zIndex: 997,
                }}
              >
                Project Number
                <span
                  style={{
                    position: "absolute",
                    minWidth: "150px",
                    right: "-120px",
                    top: "20px",
                    color: "black",
                    cursor: "pointer",
                  }}
                  onClick={() => setExpanded(!expanded)}
                >
                  {" "}
                  {expanded ? (
                    <CaretCircleDoubleRight size={32} color="#080808" />
                  ) : (
                    <CaretCircleDoubleLeft size={32} color="#080808" />
                  )}
                </span>
              </th>
              {expanded && (
                <th
                  style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    minWidth: "150px",
                    position: "sticky",
                    top: -0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  ERP System
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Cost Center
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Department{" "}
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Department Head{" "}
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  View Account Owner
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  View Team Lead{" "}
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Synergy Accounting responsible
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Synergy Quality Consultant{" "}
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Synergy Process Lead
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Synergy Department Lead
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  {" "}
                  Synergy Team
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <select
                      id="frequency-select"
                      onChange={(e) => {
                        setSelectedFrequencyId(e.target.value);
                        const dateStart = formatDate(
                          selectedDay,
                          selectedMonth,
                          selectedYear,
                        );
                        const dateEnd = formatDate(
                          selectedDay,
                          selectedMonth,
                          selectedYear,
                        );
                        fetchCustomer(
                          dateStart,
                          dateEnd,
                          true,
                          e.target.value,
                          reportingFrequencyId,
                        );
                      }}
                      value={selectedFrequencyId}
                      style={{
                        appearance: "none", // Hide default dropdown arrow
                        WebkitAppearance: "none",
                        MozAppearance: "none",
                        padding: "10px 30px 10px 10px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        backgroundColor: "white",
                        cursor: "pointer",
                        border: "none",
                      }}
                    >
                      <option value="">Frequency Voucher Processing</option>
                      {projectData
                        ?.filter((project) => project.Type === "C")
                        ?.map((project) => (
                          <option key={project.Id} value={project.Id}>
                            {project.Name}
                          </option>
                        ))}
                    </select>

                    {/* Custom Filter Icon */}
                    <FunnelSimple
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none", // Prevents clicks on the icon
                        color: "#555",
                      }}
                    />
                  </div>
                </th>
              )}

              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Bank Remittance Type
                </th>
              )}
              <th
                className="last-portion-style"
                style={{
                  position: "sticky",
                  top: 0,
                  background: "white",
                  zIndex: 10,
                }}
              >
                Received Volumes
              </th>
              <th
                className="last-portion-style"
                style={{
                  position: "sticky",
                  top: 0,
                  background: "white",
                  zIndex: 10,
                }}
              >
                Processed Volumes
              </th>
              <th
                className="last-portion-style"
                style={{
                  position: "sticky",
                  top: 0,
                  background: "white",
                  zIndex: 10,
                }}
              >
                Pending Volumes
              </th>
              <th
                className="last-portion-style"
                style={{
                  position: "sticky",
                  top: 0,
                  background: "white",
                  zIndex: 10,
                }}
              >
                Volumes &gt; 2 days
              </th>
              <th
                className="last-portion-style"
                style={{
                  position: "sticky",
                  top: 0,
                  background: "white",
                  zIndex: 10,
                }}
              >
                Comments for Volumes{" "}
              </th>
              <th
                className="last-portion-style"
                style={{
                  position: "sticky",
                  top: 0,
                  background: "white",
                  zIndex: 10,
                }}
              >
                Payment Check
              </th>
              <th
                className="last-portion-style"
                style={{
                  position: "sticky",
                  top: 0,
                  background: "white",
                  zIndex: 10,
                }}
              >
                Payment Status
              </th>
              <th
                className="last-portion-style"
                style={{
                  position: "sticky",
                  top: 0,
                  background: "white",
                  zIndex: 10,
                }}
              >
                Comments for Payment Failures
              </th>
            </tr>
          </thead>
          <tbody>
            {mergedData?.map((data, index) => {
              return (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#F1F1F1" : "#FFFFFF",
                  }}
                >
                  <td
                    style={{
                      padding: "15px",

                      fontFamily: "Poppins",
                      position: "sticky",
                      background: index % 2 === 0 ? "#F1F1F1" : "#FFFFFF",
                      left: 0,
                      zIndex: zIndex,
                    }}
                  >
                    {data?.Name}
                  </td>
                  <td
                    style={{
                      position: "sticky",
                      left: "300px",
                      padding: "15px",

                      zIndex: zIndex,
                      fontFamily: "Poppins",
                      background: index % 2 === 0 ? "#F1F1F1" : "#FFFFFF",
                    }}
                  >
                    {" "}
                    {data?.ProjectNumber}
                  </td>
                  {expanded && (
                    <td
                      style={{
                        padding: "15px",
                        border: "1px solid #fff",
                        fontFamily: "Poppins",
                      }}
                    >
                      {data?.ERPSystem}
                    </td>
                  )}
                  {expanded && (
                    <td
                      style={{
                        padding: "15px",
                        border: "1px solid #fff",
                        fontFamily: "Poppins",
                      }}
                    >
                      {/* {data?.CostCenter} */}
                      {selectedSuggestions?.length > 0
                        ? data?.CostCenterName
                        : data?.CostCenter}
                    </td>
                  )}
                  {expanded && (
                    <td
                      style={{
                        padding: "15px",
                        border: "1px solid #fff",
                        fontFamily: "Poppins",
                      }}
                    >
                      {/* {data?.Department} */}
                      {selectedSuggestions?.length > 0
                        ? data?.DepartmentName
                        : data?.Department}
                    </td>
                  )}
                  {expanded && (
                    <td
                      style={{
                        padding: "15px",
                        border: "1px solid #fff",
                        fontFamily: "Poppins",
                      }}
                    >
                      {data?.HODName}
                    </td>
                  )}
                  {expanded && (
                    <td
                      style={{
                        padding: "15px",
                        border: "1px solid #fff",
                        fontFamily: "Poppins",
                      }}
                    >
                      {data?.OwnerEMId}
                    </td>
                  )}
                  {expanded && (
                    <td
                      style={{
                        padding: "15px",
                        border: "1px solid #fff",
                        fontFamily: "Poppins",
                      }}
                    >
                      {data?.LeadId}
                    </td>
                  )}
                  {expanded && (
                    <td
                      style={{
                        padding: "15px",
                        border: "1px solid #fff",
                        fontFamily: "Poppins",
                      }}
                    >
                      {getUserFirstName(data?.SubOwner)}
                    </td>
                  )}
                  {expanded && (
                    <td
                      style={{
                        padding: "15px",
                        border: "1px solid #fff",
                        fontFamily: "Poppins",
                      }}
                    >
                      {getUserFirstName(data?.SubQC)}
                    </td>
                  )}
                  {expanded && (
                    <td
                      style={{
                        padding: "15px",
                        border: "1px solid #fff",
                        fontFamily: "Poppins",
                      }}
                    >
                      {getUserFirstName(data?.SubProcLead)}
                    </td>
                  )}
                  {expanded && (
                    <td
                      style={{
                        padding: "15px",
                        border: "1px solid #fff",
                        fontFamily: "Poppins",
                      }}
                    >
                      {getUserFirstName(data?.SubLead)}
                    </td>
                  )}
                  {expanded && (
                    <td
                      style={{
                        padding: "15px",
                        border: "1px solid #fff",
                        fontFamily: "Poppins",
                      }}
                    >
                      {getUserTeamName(data?.SubOwner)}
                    </td>
                  )}
                  {expanded && (
                    <td
                      style={{
                        padding: "15px",
                        border: "1px solid #fff",
                        fontFamily: "Poppins",
                      }}
                    >
                      {data?.ReportingFrequencyName}
                    </td>
                  )}
                  {expanded && (
                    <td
                      style={{
                        padding: "15px",
                        border: "1px solid #fff",
                        fontFamily: "Poppins",
                      }}
                    >
                      {data?.RemittanceTypeName}
                    </td>
                  )}

                  <td>
                    <input
                      type="number"
                      placeholder="Received Volume"
                      style={{
                        padding: "10px",
                        width: "100%",
                        background: "none",
                      }}
                      value={data?.ReceivedVolume}
                      onChange={(e) => {
                        handleReportChange(data, "ReceivedVolume", e);
                      }}
                    />
                  </td>

                  <td
                    style={{
                      padding: "10px",
                      width: "100%",
                      background: "none",
                    }}
                  >
                    {data?.StatusCount}
                  </td>

                  <td>
                    <input
                      type="number"
                      disabled
                      placeholder="Pending Volume"
                      value={data?.ReceivedVolume - data.StatusCount}
                      onChange={(e) => {
                        handleReportChange(data, "PendingVolume", e);
                      }}
                      style={{
                        padding: "10px",
                        width: "100%",
                        background: "none",
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      placeholder="Volume 2"
                      style={{
                        padding: "10px",
                        width: "100%",
                        background: "none",
                      }}
                      value={data?.Volume2}
                      onChange={(e) => {
                        handleReportChange(data, "Volume2", e);
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder="Comment"
                      style={{
                        padding: "10px",
                        width: "100%",
                        background: "none",
                      }}
                      value={data?.CommentOfVolume}
                      onChange={(e) => {
                        handleReportChange(data, "CommentOfVolume", e);
                      }}
                    />
                  </td>
                  <td>
                    <select
                      value={data?.PaymentCheck || ""}
                      onChange={(e) => {
                        handleReportChange(data, "PaymentCheck", e);
                      }}
                      style={{
                        padding: "10px",
                        width: "100%",
                        background: "none",
                        fontFamily: "Poppins",
                      }}
                    >
                      <option value="">Select Payment Check</option>
                      <option value="Not Applicable">Not Applicable</option>
                      <option value="Applicable">Applicable</option>
                      <td>
                        <select
                          value={data?.PaymentCheck || ""}
                          onChange={(e) => {
                            handleReportChange(data, "", e);
                          }}
                          style={{
                            padding: "10px",
                            width: "100%",
                            background: "none",
                            fontFamily: "Poppins",
                          }}
                        >
                          <option value="">Select Payment Check</option>
                          <option value="Not Applicable">Not Applicable</option>
                          <option value="Applicable">Applicable</option>

                          {/* Add this option */}
                        </select>
                      </td>

                      {/* Add this option */}
                    </select>
                  </td>
                  <td>
                    <select
                      style={{
                        padding: "10px",
                        width: "100%",
                        background: "none",
                        fontFamily: "Poppins",
                      }}
                      value={data?.PaymentStatus}
                      onChange={(e) => {
                        handleReportChange(data, "PaymentStatus", e);
                      }}
                    >
                      <option value="">Select Payment Status</option>
                      <option value="Success">Success</option>
                      <option value="Failed">Failed</option>
                      <option value="Pending">Pending</option>
                    </select>
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder="Comment on Payment Failed"
                      style={{
                        padding: "10px",
                        width: "100%",
                        background: "none",
                      }}
                      value={data?.CommentOfPaymentFaild}
                      onChange={(e) => {
                        handleReportChange(data, "CommentOfPaymentFaild", e);
                      }}
                    />
                  </td>
                </tr>

                // ))}
              );
            })}
          </tbody>
        </table>

        {loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px",
            }}
          >
            <CircularProgress style={{ color: "purple" }} width={40} />
          </div>
        )}
        {end && mergedData.length === 0 && page === 1 && (
          <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
            No data available for selected criteria
          </div>
        )}
        {end && mergedData.length > 0 && (
          <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
            No more data available
          </div>
        )}
      </div>
    </div>
  );
};

export default DailyVoucherStock;
